export default __webpack_public_path__ + "ui/assets/img/corporate-20.svg";